
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[program-name]",
      function () {
        return require("private-next-pages/[program-name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[program-name]"])
      });
    }
  